<script>
  import Container from '../layout/container.svelte';
  export let idUnico = '';
  export let content = '';
  export let videoNumber = '';
  import { onMount } from 'svelte';
  import navegacaoStore from '../../store';

  let youtubeId;

  let comandoBegin;
  let comandoEnd;
  let comandoFrase;

  let hashBegin;
  let hashEnd;
  let hash;

  onMount(() => {
    comandoBegin = content.search('<comando>');
    if (comandoBegin != -1) {
      comandoEnd = content.search('</comando>');
      if (comandoEnd != -1) {
        comandoFrase = content.substring(comandoBegin + 9, comandoEnd);
        content = content.substring(comandoEnd + 10, content.length);
      }
    }

    hashBegin = content.indexOf('<hash>');
    if (hashBegin != -1) {
      hashEnd = content.indexOf('</hash>');
      if (hashEnd != -1) {
        hash = content.substring(hashBegin + '<hash>'.length, hashEnd);
        content = content.substring(hashEnd + '</hash>'.length, content.length);
        youtubeId = hash;
      }
    }
  });
</script>

<div>
  <div class="container">
    <p class="comando">
      {@html comandoFrase}
    </p>

    <div class="video">
      <!-- <div class="icone">
        <svg
          width="67"
          height="67"
          viewBox="0 0 67 67"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M64.5 33.5C64.5 50.6208 50.6208 64.5 33.5 64.5C16.3792 64.5 2.5 50.6208 2.5 33.5C2.5 16.3792 16.3792 2.5 33.5 2.5C50.6208 2.5 64.5 16.3792 64.5 33.5Z"
            fill="url(#paint0_linear_2032_1023)"
          />
          <path
            d="M64.5 33.5C64.5 16.3792 50.6208 2.5 33.5 2.5C16.3792 2.5 2.5 16.3792 2.5 33.5C2.5 50.6208 16.3792 64.5 33.5 64.5C50.6208 64.5 64.5 50.6208 64.5 33.5ZM67 33.5C67 52.0015 52.0015 67 33.5 67C14.9985 67 0 52.0015 0 33.5C0 14.9985 14.9985 0 33.5 0C52.0015 0 67 14.9985 67 33.5Z"
            fill="white"
          />
          <path
            d="M47 31.4019C49 32.5566 49 35.4434 47 36.5981L26.75 48.2894C24.75 49.4441 22.25 48.0008 22.25 45.6914V22.3087C22.25 19.9993 24.75 18.5559 26.75 19.7106L36.875 25.5563L47 31.4019Z"
            fill="url(#paint1_linear_2032_1023)"
          />
          <path
            d="M48.2502 29.2373C51.9166 31.3543 51.9166 36.6457 48.2502 38.7627L28.0002 50.4541C24.3335 52.571 19.7502 49.9253 19.7502 45.6914V22.3086C19.7502 18.0747 24.3335 15.429 28.0002 17.5459L48.2502 29.2373ZM47 36.5981C49 35.4434 49 32.5566 47 31.4019L36.875 25.5563L26.75 19.7106L26.5617 19.6104C24.5967 18.6469 22.25 20.0713 22.25 22.3087V45.6914L22.257 45.9053C22.4008 48.0182 24.6601 49.322 26.5617 48.3897L26.75 48.2894L47 36.5981Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2032_1023"
              x1="67"
              y1="33.4999"
              x2="7.0761e-05"
              y2="33.4999"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B4CC85" />
              <stop offset="0.600962" stop-color="#B38662" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_2032_1023"
              x1="67"
              y1="33.4999"
              x2="7.0761e-05"
              y2="33.4999"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B4CC85" />
              <stop offset="0.600962" stop-color="#B38662" />
            </linearGradient>
          </defs>
        </svg>
      </div> -->
      <div class="iframe-wrapper">
        <iframe
          id="video_frame"
          title="video"
          src="https://www.youtube.com/embed/{youtubeId}?rel=0"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen="true"
          style="position:absolute;top:0;left:0;width:100%;height:100%;"
        />
      </div>
    </div>
  </div>
</div>

<style>
  .icone {
    position: absolute;
    width: 62px;
    height: 62px;
    left: -80px;
    top: 0px;
  }

  .video {
    position: relative;
  }

  #video_frame {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: white;
    clip-path: inset(1px 1px);
    filter: blur(0);
  }

  .iframe-wrapper {
    position: relative;
    /* padding-top: 56.25%; */
    z-index: 1;
    aspect-ratio: 16/9;
  }

  p.comando {
    padding: 0;
    margin: 0 0 1.5rem 0;
  }

  @media (max-width: 767px) {
    #video_frame {
      border-radius: 0;
    }

    .container {
      padding: 0;
    }

    p.comando {
      padding: 0 15px;
    }
  }
</style>
